import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import { PAGE_TYPE } from '../../constants';
import { IconFridge, IconLaptop } from './icons';
import { useLang } from '@/i18n';

const ICON1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_3894_15389)">
            <path
                d="M13 27V5.88889C13 5.39797 12.602 5 12.1111 5C8.18375 5 5 8.18375 5 12.1111V25.5C5 26.3284 5.67157 27 6.5 27H13Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M27 20.75C27.4142 20.75 27.75 20.4142 27.75 20C27.75 19.5858 27.4142 19.25 27 19.25V20.75ZM24 20.75H27V19.25H24V20.75Z" fill="#707070" />
            <path
                d="M24 11L24 10C24 7.79086 22.2091 6 20 6L13 6L13 11L24 11Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M22 14L22 11L18 11L18 14L22 14Z" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M24 20.5L24 19L17 19L17 20.5C17 22.433 18.567 24 20.5 24C22.433 24 24 22.433 24 20.5Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13 27L26.4 27C26.7314 27 27 26.7314 27 26.4C27 25.0745 25.9255 24 24.6 24L13 24L13 27Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3894_15389">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const ICON3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_3894_15435)">
            <path
                d="M24.5 28H7.5C6.67157 28 6 27.3284 6 26.5V5.5C6 4.67157 6.67157 4 7.5 4H24.5C25.3284 4 26 4.67157 26 5.5V26.5C26 27.3284 25.3284 28 24.5 28Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6 22H26" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 25H23" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 8 26)" fill="#707070" />
            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 26)" fill="#707070" />
            <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 14 26)" fill="#707070" />
            <circle cx="6" cy="6" r="6" transform="matrix(1 0 0 -1 10 19)" stroke="#707070" strokeWidth="1.5" />
        </g>
        <defs>
            <clipPath id="clip0_3894_15435">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const { pageType } = useProductStore();

    return (
        <div className="ef-container TabA-card card-b">
            <div className="TabA-card-l">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1725851346497/pc_taba_2.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1725851345552/m_taba_2.jpg"
                />
            </div>
            <div className="TabA-card-r">
                <div className="TabA-card-r-in">
                    <div className="TabA-card-title">{t('b_title')}</div>
                    <div className="TabA-card-list">
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <ICON1 />
                            </div>
                            <div className="TabA-card-item-text1">
                                1<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('b_item1_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconFridge />
                            </div>
                            <div className="TabA-card-item-text1">
                                24<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('b_item2_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <ICON3 />
                            </div>
                            <div className="TabA-card-item-text1">
                                {pageType === PAGE_TYPE.BASE ? 1 : 2}
                                <span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('b_item3_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconLaptop />
                            </div>
                            <div className="TabA-card-item-text1">
                                24<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('b_item4_t2')}</div>
                        </div>
                    </div>
                    <div className="TabA-card-bg">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1726639175672/RV.png" />
                    </div>
                    <div className="TabA-card-tag">{t('b_text1')}</div>
                    <div className="TabA-card-tips">{t('b_text2')}</div>
                </div>
            </div>
        </div>
    );
}
